import React from 'react';
import { getDaysBetween, getSprint } from '../lib/game-logic';
import { Profile } from '../types/centurion';
interface DayIndicatorProps {
  profile: Profile;
  todayStr: string;
}
export function DayIndicator({
  profile,
  todayStr
}: DayIndicatorProps) {
  const dayNumber = getDaysBetween(profile.startDate, todayStr) + 1;
  const sprint = getSprint(dayNumber);
  const daysRemaining = 100 - dayNumber;
  return <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-surface-200 border border-surface-100 rounded-lg p-4 sm:p-6 mb-8 shadow-lg" data-id="element-129">
      <div data-id="element-130">
        <h2 className="text-sm uppercase tracking-widest text-gray-500 font-semibold mb-1" data-id="element-131">
          Current Status
        </h2>
        <div className="flex items-baseline gap-3" data-id="element-132">
          <span className="text-4xl sm:text-5xl font-mono-num font-bold text-centurion-500" data-id="element-133">
            DAY {dayNumber}
          </span>
          <span className="text-lg text-gray-400 font-mono-num" data-id="element-134">/ 100</span>
        </div>
      </div>

      <div className="flex gap-4 sm:gap-8 mt-4 sm:mt-0" data-id="element-135">
        <div className="flex flex-col items-start sm:items-end" data-id="element-136">
          <span className="text-xs uppercase tracking-wider text-gray-500" data-id="element-137">
            Sprint
          </span>
          <span className="text-xl font-mono-num font-bold text-gray-200" data-id="element-138">
            {sprint}{' '}
            <span className="text-sm text-gray-500 font-normal" data-id="element-139">/ 4</span>
          </span>
        </div>
        <div className="flex flex-col items-start sm:items-end" data-id="element-140">
          <span className="text-xs uppercase tracking-wider text-gray-500" data-id="element-141">
            Resets
          </span>
          <span className="text-xl font-mono-num font-bold text-red-500" data-id="element-142">
            {profile.resetCount}
          </span>
        </div>
        <div className="flex flex-col items-start sm:items-end" data-id="element-143">
          <span className="text-xs uppercase tracking-wider text-gray-500" data-id="element-144">
            Remaining
          </span>
          <span className="text-xl font-mono-num font-bold text-gray-200" data-id="element-145">
            {daysRemaining}
          </span>
        </div>
      </div>
    </div>;
}